(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-wholesale"]) return;
  try {
    
  // ── View switcher ──
  const STORAGE_KEY = 'wt-view';
  const switcher = document.querySelector('.wt-view-switcher');
  const views = document.querySelectorAll('.wt-view');

  function setView(name) {
    views.forEach(v => {
      const active = v.dataset.view === name;
      v.hidden = !active;
    });
    if (switcher) {
      switcher.querySelectorAll('.wt-view-btn').forEach(btn => {
        btn.setAttribute('aria-pressed', btn.dataset.view === name ? 'true' : 'false');
      });
    }
    try { localStorage.setItem(STORAGE_KEY, name); } catch (_) {}
  }

  if (switcher) {
    switcher.querySelectorAll('.wt-view-btn').forEach(btn => {
      btn.addEventListener('click', () => setView(btn.dataset.view));
    });
  }

  // Restore saved preference
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'grid' || saved === 'table') setView(saved);
  } catch (_) {}

  // ── Shared ATC logic ──
  function getSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(el => ids.push(el.dataset.sectionId));
    return ids;
  }

  async function addToCart(atcBtn, variantId, qty) {
    atcBtn.classList.add('is-loading');
    atcBtn.disabled = true;

    try {
      const body = { id: variantId, quantity: qty };
      const sectionIds = getSectionIds();
      if (sectionIds.length) body.sections = sectionIds.join(',');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.message || 'Error');

      atcBtn.classList.remove('is-loading');
      atcBtn.dataset.added = 'true';
      atcBtn.addEventListener('animationend', () => {
        setTimeout(() => { atcBtn.removeAttribute('data-added'); atcBtn.disabled = false; }, 800);
      }, { once: true });

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: data, sourceId: variantId, data: { source: 'wholesale-collection', itemCount: qty, sections: data.sections || {} } },
      }));

    } catch (_) {
      atcBtn.classList.remove('is-loading');
      atcBtn.disabled = false;
      const label = atcBtn.querySelector('.wt-atc-label span span');
      if (label) {
        const orig = label.textContent;
        label.textContent = 'Error — try again';
        setTimeout(() => { label.textContent = orig; }, 2000);
      }
    }
  }

  // ── Init each item (table row or grid card) ──
  function initItem(item) {
    const variantSelect = item.querySelector('.wt-variant-select');
    const priceEl = item.querySelector('.wt-price');
    const skuEl = item.querySelector('.wt-sku');
    const atcBtn = item.querySelector('.wt-atc-btn');
    const qtyInput = item.querySelector('.wt-qty-input');

    item.querySelectorAll('.wt-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val + parseInt(btn.dataset.dir, 10));
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const opt = variantSelect.options[variantSelect.selectedIndex];
        const available = opt.dataset.available === 'true';
        if (priceEl) priceEl.textContent = formatMoney(parseInt(opt.dataset.price, 10));
        if (skuEl) skuEl.textContent = opt.dataset.sku || '—';
        atcBtn.dataset.variantId = opt.value;
        atcBtn.disabled = !available;
        const label = atcBtn.querySelector('.wt-atc-label span span');
        if (label) label.textContent = available ? 'Add to cart' : 'Out of stock';
        const icon = atcBtn.querySelector('.add-to-cart-icon');
        if (icon) icon.style.display = available ? '' : 'none';
        const img = item.querySelector('.wt-card__image');
        if (img && opt.dataset.image) {
          img.removeAttribute('srcset');
          img.src = opt.dataset.image;
        }
      });
    }

    atcBtn.addEventListener('click', () => {
      if (atcBtn.classList.contains('is-loading')) return;
      addToCart(atcBtn, atcBtn.dataset.variantId, parseInt(qtyInput.value, 10) || 1);
    });
  }

  document.querySelectorAll('.wt-item').forEach(initItem);

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#cookie-consent"]');
    if (!link) return;
    e.preventDefault();
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.openConsentDialog();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  } catch(e) { console.error(e); }
})();
})();
